import type { BillingInterval, PlanId } from '@tandemone/types'
import { useQuery } from '@tanstack/react-query'

import { getPlanChangePreview } from './api'

/* never cached: a stale quote is a wrong number next to a button that charges
 * a card. */
export function usePlanChangePreview(
  choice: { planId: PlanId; interval: BillingInterval } | null
) {
  return useQuery({
    queryKey: ['billing', 'change-preview', choice?.planId, choice?.interval],
    queryFn: ({ signal }) =>
      getPlanChangePreview(choice!.planId, choice!.interval, signal),
    enabled: choice !== null,
    staleTime: 0,
    gcTime: 0
  })
}
